<template>
  <div :class="{'container-fluid':keepCardContainer, 'card':keepCardContainer}">
    <div class="card-section" v-for="section in layout.sections" v-if=mainSection(section)>
      <h1 class="section-title">{{ section.title }}</h1>
      <div class="row section-body">
          <div class="col-sm-3 section-property-block" v-for=" field in section.fields" v-show="showField(field.field_name)">
            <p class="section-property-title">{{ field.display_name }}</p>
            <p @click="edit(field.field_name)">
              <div v-if="field.field_type == 'choice'">
                <select class="section-property">
                  <option v-for="option in field.options"
                          :selected="option.option_name == getData(field.field_name)? 'selected' : ''"
                          :value="option.option_name">{{ option.option_name }}
                  </option>
                </select>
              </div>
              <div v-else>
                  <div v-if="field.field_type == 'radio' || field.field_type == 'checkbox'">
                      <input v-for="(option, index) in field.options" :id="field.field_name + index"
                          type="field.field_type" name="field.field_name"
                          :checked="option.option_name == getData(field.field_name)? 'checked' : ''"
                          :value="getData(field.field_name)" />{{ option.option_name }}<br>
                  </div>
                  <div v-else>
                    <div v-if="field.field_type == 'date' || field.field_type == 'datetime'">
                      <dropdown class="form-group">
                        <div class="input-group">
                          <input id="group-created" disabled="disabled" type="text" 
                              name="name" placeholder="--"
                              :value="getData(field.field_name) | formatDateTime('MMMM DD YYYY, hh:mm A')"/>
                          <div class="input-group-btn">
                            <btn class="dropdown-toggle" disabled><i class="glyphicon glyphicon-calendar"></i></btn>
                          </div>
                        </div>
                        <template slot="dropdown">
                          <li>
                            <date-picker/>
                          </li>
                        </template>
                      </dropdown>
                    </div>
                    <div v-else>
                      <input :id="field.field_name" class="section-property"
                          placeholder="--"
                         :type="field.field_type"
                         :disabled="false"
                         :value="getData(field.field_name)">
                    </div>
                  </div>
              </div>
            </p>
          </div>
      </div>
    </div>

    <div class="card-section sub-section" v-for="section in layout.sections" v-if="isSecondarySection(section)">
      <h6 class="section-title">{{ section.title }}</h6>
      <div class="row section-body">
        <div v-if="isDetailed(section.title)" class="col-sm-3 section-property-block" v-for="field in section.fields">
            <p class="section-property-title">{{ field.display_name }}</p>
            <p @click="edit(field.field_name)">
              <input
              :id="field.field_name"
              class="section-property"
              type="text"
              :value="getExtraDetailsValue(section.title, field.display_name, field.field_name)"
              :disabled="false">
            </p>
        </div>
        <div  v-else-if="isDropdown(section.title)" class="col-sm-12 section-property-block dpdwn" >
            <div class="row">
                <div class="col-sm-4">
                  <p class="section-property-title">{{ field.display_name }}</p>
                  <multi-select
                    v-model="multiSelectModel" :label-key="field.field_name"
                    :options="options"
                    :selected="selected"
                    :track-by="field.field_name"
                    filterable block/>
                </div>
                <div class="col-sm-1">&nbsp;</div>
          </div>

        </div>
      </div>
    </div>
    <!-- drop the thingy here -->
    <div class="card-section sub-section">
      <div class="row section-body button">
        <div class="col-sm-3 section-property-block">
          <btn type="primary" @click="save()">{{ action }}</btn>
          <btn v-if="action != 'create'" type="danger" @click="deleteDetail()">delete</btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import $ from 'jquery';
import constants  from '../constants.js';
import moment from 'moment';
import { GenericUpdateCreate } from '../api';
import store from '../store.js';
import Vue from 'vue';
import Selectize from 'vue2-selectize';
import _ from 'lodash';
import VueSelect from 'vue-select';
import { MultiSelect } from 'uiv'


export default{
    props: {
      detail: {
        default: () => ''
      },
      layout: {
        default: () => ({ })
      },
      pageName: '',
      keepCardContainer: { default: true },
      editable: {
        type: Array,
        default: () => []
      },

      detailBody:{
        default: () => ({})
      },
      action: ''
    },
    created(){
      this.tooltipId = Math.floor(Math.random() * (9999999 - 10000 + 1)) + 10000;
      console.log(this.$children)
    },
    data: function(){
      return {
        options: [{ name: 'Vue.js', language: 'JavaScript' },
        { name: 'Adonis', language: 'JavaScript' },
        { name: 'Rails', language: 'Ruby' },
        { name: 'Sinatra', language: 'Ruby' },
        { name: 'Laravel', language: 'PHP' },
        { name: 'Phoenix', language: 'Elixir' }],
        selected: [],
        optionsContainer: {},
        multiSelectModel: [],
        test: 0,
        toolTips: ['email', 'alternate_email'],
        tooltipId: '',
        details: {},
        extraDetailsDropdownLayout: ['Tags', 'Users', 'Permissions', 'Groups', 'Data Sources'],
        extraDetailsDetailedLayout: ['Contacts'],
        extraDetailsToBeAdded: [],
        extraDetailsToBeRemoved: [],
        settings: { maxItems: null}
      };
    },
    computed: {
      ...mapState({
        dateFields: state => state.dateFields,
        dateFormat: state => state.dateFormat,
        SelectedUser: state => state.SelectedUser
      }),
      secondarySections: function () {
        return _.flattenDeep(
          [this.extraDetailsDetailedLayout, this.extraDetailsDropdownLayout]
        )
      },
      extraDetails: function () {
        let extraDetails = {};
        for (var key in this.detailBody) {
          if (this.detailBody.hasOwnProperty(key)) {
            if(Array.isArray(this.detailBody[key])){
              extraDetails[key] = this.detailBody[key];
              console.log(key);
            }
          }
        }
        return extraDetails;
      },
      newDetailBody: function () {
        let newDetailBody = {};
        for (var key in this.detailBody) {
          if (this.detailBody.hasOwnProperty(key)) {
            if(!Array.isArray(this.detailBody[key])){
              newDetailBody[key] = this.detailBody[key];
            }
          }
        }
        return newDetailBody;
      },
      activeDetails: function () {
        return store.state[this.detail]
      },
    },
    methods: {
      getOptions (title) {
        let options = this.optionsContainerBuilder(title).newOptionsTitle;
        return this.optionsContainer[options];
      },
      getSelected (title) {
        let selected = this.optionsContainerBuilder(title).newSelectedTitle;
        return this.optionsContainer[selected];
      },
      optionsContainerBuilder (title) {
        let newOptionsTitle = title + '@options';
        let newSelectedTitle = title + '@selected';

        return {'newOptionsTitle': newOptionsTitle, 'newSelectedTitle': newSelectedTitle};
      },
      showNotification (type, content) {
        this.$notify({
          type: type,
          content: content
        });
      },
      showField: function (section) {
        for (var i = 0; i < this.extraDetailsDropdownLayout.length; i++) {
          if (_.startCase(section) === _.startCase(this.extraDetailsDropdownLayout[i])) return false;
        }
        return true;
      },
      removeExtraDetails: function (detail) {
        this.extraDetailsToBeRemoved.push(detail[0]);
      },
      addExtraDetails: function (detail) {
        this.extraDetailsToBeAdded.push(detail[0])
      },
      appendTo (title) {
        let _title = _.lowerCase(title);
        console.log(_title);
      },
      isDetailed (title) {
        let retVal = false;
        for (let layout of this.extraDetailsDetailedLayout) {
          if (title == layout) {
            retVal = true;
            break;
          };
        }
        console.log('IS DETAILED TITLE', title, retVal);
        return retVal;
      },
      isDropdown (title) {
        let retVal = false;
        this.getExtraDetailsData(title);
        for (let layout of this.extraDetailsDropdownLayout) {
          if (title == layout) {
            retVal = true;
            break;
          };
        }
        console.log('IS DROPDOWN TITLE', title, retVal);
        return retVal;
      },
      mainSection(section) {
        for (let layout of this.secondarySections) {
          if (section.title == layout) return false;
        }
        return true;
      },
      isSecondarySection(section) {
        for (let layout of this.secondarySections) {
          if (section.title == layout) return true;
        }
        return false;
      },
      deleteDetail: async function () {
         let componentToSave = this.$route.fullPath.split('/')[1];
         let id = this.$route.fullPath.split('/')[2];
         let request = await GenericUpdateCreate.delete(componentToSave, id);
         this.showNotification('success', 'Deletion successful');
         this.$router.push(`/${componentToSave}`);
      },
      save: async function () {
        let _this = this;
        let request = null;
        $('input[type=text]').each(function(){
            $(this).prop('disabled', true);
        })

        $('input[type=text]').each(function(){
            let key = $(this).attr('id');
            let value = $(this).val();
            _this.details[key] = value;
        })
        let data = this.details;
        let componentToSave = this.$route.fullPath.split('/')[1];
        let id = this.$route.fullPath.split('/')[2];
        let action = this.action;
        console.log("Data: ", data)
        if (this.action === 'save') {
          request = await GenericUpdateCreate.create(data, componentToSave);
        } else if (this.action === 'update') {
          request = await GenericUpdateCreate.update(data, componentToSave, id);
        }

        if (request !== undefined && request !== null) {
         this.showNotification('success', ` ${this.pageName} successfully updated.`);
        }
        else{
          this.showNotification('danger', `An error occured while updating ${this.pageName}`);
        }
        // store.dispatch('updateModel', { data, componentToSave, id, action });
      },
      edit: function (elementId) {
        // $('input[type=text]').each(function(){
        //     $(this).prop('disabled', true);
        // })
        $(`#${elementId}`).prop('disabled', false);

        // $(`#${elementId}`).blur(function(){
        //   $(this).prop('disabled', true);
        // })
      },
      isEditable: function(prop){
        if(this.editable.length == 1 && this.editable[0] == '*'){
          return false;
        }
        var isEditable = true;
        for (var i = 0; i < this.editable.length; i++) {
          if(this.editable[i] == prop){
              isEditable = false;
          }
        }
        return isEditable;
      },
      cleanSection: function(section){
        var _section = section;
        if(section == '' || section == undefined){
            _section =  '--';
        }
        return _section;
      },
      isDecimal: function(decimal){
        let re = new RegExp(/^\d*\.(\d)+$/, 'g');
        let isDecimal = '';
        if(decimal !== undefined && typeof decimal == 'string'){
          isDecimal = decimal.match(re);
          return isDecimal === null ? decimal : '$' + decimal;
        }
      },

      getData: function(propertyName) {
        let _data = this.newDetailBody[propertyName];

        if(this.dateFields.includes(propertyName)){
          _data = moment(_data).format(this.dateFormat);
        }else if(_data === undefined && propertyName == 'customer'){
          _data = this.SelectedUser['first_name'] + ' ' + this.SelectedUser['last_name'];
        }
        return _data == undefined ? null : _data;
      },

      getExtraDetailsValue: function (section, target, indicator) {
        let value = "--";
        let _section = _.lowerCase(section);
        let _data = this.extraDetails[_section];

        target = _.lowerCase(target);
        _data.forEach(function(item) {
          var items = Object.keys(item);
          items.forEach(function(key) {
            if (item[key] == target) {
                value = item[indicator];
            }
         });
        });
        return value;
      },
      getExtraDetailsData: function (section) {
        let _section = _.snakeCase(section);
        let _data = this.extraDetails[_section];
        let containers = this.optionsContainerBuilder(section)
        let _extraDetails = _data === undefined ? [] : _data;
        let newOptionsTitle = containers.newOptionsTitle;
        let newSelectedTitle = containers.newSelectedTitle;
        this.optionsContainer[newSelectedTitle] = _extraDetails;
        this.optionsContainer[newOptionsTitle] = _extraDetails;
        console.log('THE DATA: ', _extraDetails);
      },
    },
    components: {
      Selectize,
      VueSelect,
      MultiSelect
    }
};
</script>

<style scoped lang="scss">
@import "../css/constants";
input, textarea, select { 
  font-family: 'Roboto', sans-serif; 
  outline: none; 
  border: none; 
  color: #90949c; 
  font-size: 14px; 
}

input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  border-bottom: 1px solid #c3c3c3;
}

/* body select.select_box */
select {
  display: block;
  padding: 6px 0px !important;
  max-width: 100%;
  height: auto !important;
  border: none !important;
  border-radius: 0px;
  background: transparent;
  border-bottom: 1px solid #c3c3c3 !important;

  font-size: 16px;
  line-height: 16px !important;
  appearance: none; /* this is must */
  -webkit-appearance: none;
  -moz-appearance: none;
}

/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
textarea {
    width: 60%;
    max-width: 60%;
    min-width: 60%;
    height: 50px;
    max-height: 50px;
    min-height: 50px;
    border-bottom: 1px solid #c3c3c3;
    padding: 0;
    overflow: auto;
}
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    margin-top: 25px;
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }
.sub-section { margin-top: 25px; }
.section-title {
    font-family: 'Roboto Slab', serif;
    font-weight: bold;
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    font-family: 'Roboto Slab', serif;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    font-family: 'Roboto Slab', serif;
    font-weight: regular;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

  button.save {
    width: 100px;
    height: $p32;
    border: 1px solid $gray4;
    border-radius: 4px;
    background-color: white;
    font-size: $p14;
    color:grey;
    &:focus {
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailCard.vue